var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgScoreIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 6,
    viewBox: "0 0 7 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_295_5535)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.67969 2.72197L3.47588 0.925781L5.27207 2.72197",
    stroke: "#60D39C",
    strokeWidth: 1.29611,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.47656 5.23664V0.925781",
    stroke: "#60D39C",
    strokeWidth: 1.29611,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_295_5535"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5.74782,
    height: 5.74782,
    fill: "white",
    transform: "translate(0.601562 0.207031)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgScoreIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/score-icon.7d24d194d8eb51de818d13de75689a20.svg";